import React, { Component } from 'react';
import './RemoveModal.css';
import {Button, Modal} from 'react-materialize';

class RemoveModal extends Component {

	render() {
		return (
      <Modal trigger={<Button className='remove' icon='close'></Button>} header='Tem certeza?'
        actions={
          <div>
            <button className="cancela waves-effect waves-light btn-flat modal-action modal-close" onClick={this.closeModal}>Cancelar</button>
            <button value={this.props.index} className="remove waves-effect waves-light btn-flat modal-action modal-close" onClick={(e) => this.props.apaga(e.target.value)}>Apagar</button>
          </div>
        }>
        <div>
          Deseja apagar esse Gráfico?
        </div>
      </Modal>   
		)
	}


}

export default RemoveModal;


// WEBPACK FOOTER //
// ./src/components/RemoveModal.js